<template>
  <div class="plate-container">
    <div class="plate">
      <span class="number">{{ value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "00-XX-000",
    },
  },
};
</script>

<style scoped>
.plate-container {
  display: inline-block;
  text-align: center;
}

.plate {
  width: 180px; /* Reduced width */
  height: 40px; /* Reduced height */
  background: url("/dqn.svg") no-repeat center center;
  background-size: 90% 90%; /* Scale down SVG background */
  padding-top: 4px; /* Reduced top padding */
  padding-left: 20px; /* Reduced left padding */
  display: flex;
  justify-content: center;
  align-items: center;
}

.number {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 1.6em; /* Reduced font size */
  font-weight: bold;
  color: #333;
}
</style>
